import { create } from "zustand";
import {
	WebchatCustomerClosedActions,
	WebchatCustomerClosedState,
} from "./types";

// Fed live by the WebchatCustomerClosed notification and, after a reload, from the closed marker the
// transcript itself carries (useWebchatMessaging) — the notification is long gone by then.
export const useWebchatCustomerClosedStore = create<
	WebchatCustomerClosedState & WebchatCustomerClosedActions
>((set) => ({
	closedByConversationId: {},
	markClosed: (conversationId: string) =>
		set((state) =>
			state.closedByConversationId[conversationId]
				? state
				: {
						closedByConversationId: {
							...state.closedByConversationId,
							[conversationId]: true,
						},
					}
		),
	clear: (conversationId: string) =>
		set((state) => {
			const { [conversationId]: _, ...rest } = state.closedByConversationId;

			return { closedByConversationId: rest };
		}),
}));
